import { Button, Stack } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import {
  selectedFilteredDeckIds,
  selectedFilteredPaintRegionIds,
  applyFilters,
  selectedTemplateFiltersState,
  selectedFilteredWorkpackIds,
  isAllComponentsSelected,
  selectedAssemblyIds,
} from '@/components/Analysis/state';
import { selectedInspectionPlanId } from '@/components/Analysis/state';

type Props = {
  onClear?: () => void;
};

export const FilterActions = ({ onClear }: Props) => {
  const setSelectedTemplateFilters = useSetAtom(selectedTemplateFiltersState);
  const setSelectedDeckIds = useSetAtom(selectedFilteredDeckIds);
  const setSelectedPaintRegionIds = useSetAtom(selectedFilteredPaintRegionIds);
  const setApplyFilters = useSetAtom(applyFilters);
  const setSelectedWorkpackIds = useSetAtom(selectedFilteredWorkpackIds);
  const setAllComponentsSelected = useSetAtom(isAllComponentsSelected);
  const setSelectedAssemblyIds = useSetAtom(selectedAssemblyIds);
  const setSelectedInspectionPlanId = useSetAtom(selectedInspectionPlanId);
  const clearFilters = useCallback(() => {
    setSelectedTemplateFilters([]);
    setSelectedDeckIds([]);
    setSelectedPaintRegionIds([]);
    setSelectedWorkpackIds([]);
    setAllComponentsSelected(false);
    setSelectedAssemblyIds([]);
    setApplyFilters(true);
    setSelectedInspectionPlanId('default');
    if (onClear) {
      onClear();
    }
  }, [
    onClear,
    setAllComponentsSelected,
    setApplyFilters,
    setSelectedAssemblyIds,
    setSelectedDeckIds,
    setSelectedPaintRegionIds,
    setSelectedTemplateFilters,
    setSelectedWorkpackIds,
    setSelectedInspectionPlanId,
  ]);

  return (
    <Stack data-testid="filter-actions" direction="row" spacing={2}>
      {false && (
        <Button sx={{ fontSize: '1rem' }} startIcon={<SaveIcon />} id="save-query-button">
          Save Query
        </Button>
      )}
      <Button
        id="clear-query-button"
        data-testid="clear-query-button"
        sx={{ fontSize: '1.2rem', textTransform: 'none' }}
        startIcon={<CancelIcon />}
        onClick={() => clearFilters()}
      >
        Clear Query
      </Button>
    </Stack>
  );
};
